import { isNil } from 'lodash'

import { createOrUpdateBankApi } from '@eastcoal/api/finance/bank/createOrUpdateBank'
import { queryBankApi } from '@eastcoal/api/finance/bank/queryBank'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { CrudModalForm } from '@eastcoal/formily/components/CrudModalForm'
import { CrudModalFormProps } from '@eastcoal/formily/components/CrudModalForm/interface'
import { CancelButton } from '@eastcoal/formily/components/CrudModalForm/shared/CancelButton'
import { SaveButton } from '@eastcoal/formily/components/CrudModalForm/shared/SaveButton'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { Select } from '@eastcoal/formily/components/Select'
import { useCreationForm } from '@eastcoal/formily/hooks/useCreationForm'

import { BankCardInput } from '@eastcoal/shared/@formily/BankCardInput'

import { useMemberBankListStore } from '../Store/hooks/useStore'

const schema: SchemaItem[] = [
  {
    type: 'string',
    name: 'id',
    'x-display': 'hidden'
  },
  {
    type: 'number',
    name: 'bankType',
    title: '账户类型',
    required: true,
    enum: [
      {
        label: '个人账户',
        value: 0
      },
      {
        label: '企业账户',
        value: 1
      }
    ],
    'x-decorator': FormItem,
    'x-component': Select,
    'x-component-props': {
      disabled: true
    }
  },
  {
    type: 'string',
    name: 'receiver',
    required: true,
    title: '{{ $values.bankType === 0 ? "收款人" : "收款单位" }}',
    'x-decorator': FormItem,
    'x-component': Input,
    'x-component-props': {
      disabled: true
    }
  },
  {
    type: 'object',
    name: `{
        bankAccount,
        bankName 
      }`,
    title: '银行账号',
    'x-decorator': FormItem,
    'x-component': BankCardInput,
    'x-component-props': {
      type: '{{ $values.bankType }}',
      placeholder:
        '{{ $values.bankType === 0 ?"请输入银行账号后，点击识别":"请输入银行账号" }}'
    },
    'x-validator': [
      {
        required: true,
        validator(value) {
          return !isNil(value.bankAccount) && value.bankAccount !== ''
            ? ''
            : '银行卡不能为空'
        }
      }
    ]
  },
  {
    type: 'string',
    name: 'bankName',
    title: '开户银行',
    required: true,
    'x-decorator': FormItem,
    'x-component': Input
  },
  {
    type: 'string',
    name: 'bankBranch',
    title: '开户支行',
    'x-decorator': FormItem,
    'x-component': Input
  }
]

const readApi: CrudModalFormProps['readApi'] = ({ id }) => {
  return {
    api: () => queryBankApi({ id }),
    ready: !isNil(id),
    refreshDeps: [id]
  }
}

export const MemberBankForm = () => {
  const {
    tableRef,
    member,
    memberType,
    formMode,
    setFormMode,
    currentAccountId,
    accountFormVisible,
    toggleAccountFormVisible
  } = useMemberBankListStore(state =>
    pick(state, [
      'tableRef',
      'member',
      'memberType',
      'formMode',
      'setFormMode',
      'currentAccountId',
      'accountFormVisible',
      'toggleAccountFormVisible'
    ])
  )

  const form = useCreationForm({
    initialValues: {
      memberId: member?.id,
      memberName: member?.name,
      bankType: memberType,
      receiver: member.name
    }
  })

  const { message } = useFeedback()

  const hnadleSubmitSuccess = () => {
    message.success('操作成功')
    tableRef.current?.reload()
  }

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      form.reset()
    }
    toggleAccountFormVisible()
  }

  return (
    <CrudModalForm
      createApi={createOrUpdateBankApi}
      form={form}
      mode={formMode}
      name='memberBankForm'
      open={accountFormVisible}
      readApi={readApi}
      schema={schema}
      size={550}
      type='drawer'
      updateApi={createOrUpdateBankApi}
      actions={[
        <CancelButton key='backButton' />,
        <SaveButton key='saveButton' type='primary'>
          提交
        </SaveButton>
      ]}
      context={{
        id: currentAccountId
      }}
      onModeChange={setFormMode}
      onOpenChange={handleOpenChange}
      onSuccess={hnadleSubmitSuccess}
    />
  )
}
